import React, { Component } from "react"
import Img from 'gatsby-image'

class Grid extends Component {
  componentDidMount() {
    const isBrowser = typeof window !=='undefined'
    const Isotope  = isBrowser? require('isotope-layout') : undefined

    let elem = document.querySelector('.gridHouse')

    let iso = new Isotope( elem, {
      itemSelector: '.gridHouseItem',
      layoutMode: 'fitRows'
    })

    let filtersElem = document.querySelector('.filtersButtonGroup')
    filtersElem.addEventListener( 'click', function( event ) {
      let filterValue = event.target.getAttribute('data-filter')
      iso.arrange({ filter: filterValue })
    })

    const buttonGroups = document.querySelectorAll('.filtersButton')

    for ( let i=0, len = buttonGroups.length; i < len; i++ ) {
      var buttonGroup = buttonGroups[i]
      radioButtonGroup( buttonGroup )
    }

    function radioButtonGroup( buttonGroup ) {
      buttonGroup.addEventListener( 'click', function( event ) {
        buttonGroup.querySelector('.is-checked').classList.remove('is-checked')
        event.target.classList.add('is-checked')
      })
    }

    const imageGroups = document.querySelectorAll('#house-grid__images')
    const modal = document.querySelector('.house-grid__modal')
    const modalImg = document.getElementById("house-grid__modal__img")
    const closeModal = document.querySelector(".house-grid__modal__close")

    for ( let i=0, len = imageGroups.length; i < len; i++ ) {
      var imageGroup = imageGroups[i]
      getImage( imageGroup )
    }

    function getModal() {
      modal.style.display = "block"
    }

    function getImage(img) {
      modalImg.src = img
    }

    function getImage( imageGroup ) {
      imageGroup.addEventListener( 'click', function( event ) {
        if (imageGroup.querySelector('.selected')) {
          imageGroup.querySelector('.selected').classList.remove('selected')
          event.target.classList.add('selected')
          getModal()
          modalImg.src = event.target.src
        } else {
          event.target.classList.add('selected')
          getModal()
          modalImg.src = event.target.src
        }
      })
    }

    //closeModal.onClick = closeMenu()
    closeModal.onclick = function() {
      modal.style.display = "none"
    }

  }

  render() {

    let rooms = this.props.rooms

    return(
      <div>
        <div className="wrap">
          <div className="house-grid">
            <div className="house-grid__title">
              Gallery
            </div>
            <div className="filtersButton filtersButtonGroup house-grid__filters">
              <ul>
                <li
                  data-filter="*"
                  className="is-checked house-grid__filter"
                >
                  All
                </li>
                { rooms.map(room => {
                  let filterName = room.kind.name.replace(/[^a-zA-Z0-9]/g,'')
                  return(
                    <li
                      data-filter={`.${filterName}--grid`}
                      key={ room.id }
                      className="house-grid__filter"
                    >
                      { filterName }
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
        <div className="house-grid__grid">
          <div className="house-grid__modal">
            <div className="house-grid__modal__body">
              <span
                className="house-grid__modal__close"
              />
              <img
                id="house-grid__modal__img"
                className="house-grid__modal__image"
              />
            </div>
          </div>
          <div className="gridHouse" id="house-grid__images">
            { rooms.map(room => {
              let label = room.kind.name.replace(/[^a-zA-Z0-9]/g,'')
              return (
                room.gallery.map(rg => {
                  return(
                    <div
                      key={ rg.id }
                      className={`gridHouseItem ${ label }--grid house-grid__item`}
                    >
                      <div
                        className="house-grid__item__inner"
                      >
                        <Img
                          sizes= { rg.sizes }
                          style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 10
                          }}
                        />
                      </div>
                    </div>
                  )
                })
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid/index.js